import { ApiV1 } from "./Api";

const listarCursos = () => {
  return ApiV1().get("/cursos");
};

export { listarCursos };
